<script>
    import { beforeUpdate, onMount, onDestroy } from 'svelte';
    import timeout from './timeout.js';
    import defaultState from './defaultState.js';
    import { getContext } from 'svelte'; const dispatch = getContext('dispatch');

    export let value;
    export let rolling;


    const roll = () => {
        const face = Math.floor(Math.random() * 6);
        return face + 1;
    }

    let animationFrame = 0;
    const animationMaxFrames = 20;
    const frameDelay = 0.17;
    let animationFrameId = 0;
    let timeoutId = 0;
    const cancelTimers = () => {
            if (timeoutId !== 0) {
                clearTimeout(timeoutId);
                timeoutId = 0;
            }
            if (animationFrameId !== 0) {
                cancelAnimationFrame(animationFrameId);
                animationFrameId = 0;
            }
    }
    const updateAnimation = (delay = 0) => {
        if (!rolling) {
            return;
        }
        if (delay !== 0) {
            cancelTimers();
            timeoutId = timeout(delay, () => {
                timeoutId = 0;
                updateAnimation();
            });
        } else {
            animationFrameId = requestAnimationFrame(() => {
                animationFrameId = 0;
                if (!rolling) {
                    return;
                }
                animationFrame += 1;
                value = roll();
                if (animationFrame === animationMaxFrames) {
                    animationFrame = 0; // reset for next time
                    rolling = false;
                    dispatch({roll: value});
                } else {
                    updateAnimation(0.17);
                }
            });
        }
    };
    onMount(() => {
        cancelTimers();
        updateAnimation();
    });
    beforeUpdate(() => {
        if (timeoutId === 0 && animationFrameId === 0) {
            updateAnimation();
        }
    });
    onDestroy(cancelTimers);
</script>

<style lang="less">
    @width: 210px;
    @height: 210px;
    @pipOffset: 23%; /* from left edge to center of left pips */
    @pipWidth: 18%;
    @halfPip: (@pipWidth / 2);
    @rightPip: (100% - @pipOffset - @halfPip);
    @middlePip: (50% - @halfPip);
    @leftPip: (@pipOffset - @halfPip);
    @topPip: @leftPip;
    @bottomPip: @rightPip;
    div.outer1 {
        width: @width;
        max-width: 100%;
        margin: 30px auto;
    }
    div.outer2 {
        padding-top: 100%;
        position: relative;
    }
    div.outerCircle {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 100%;
        box-sizing: border-box;
        padding: 25%;
    }
    div[data-value] {
        position: relative;
        background: white;
        border: 1px solid #aaa;
        border-radius: 12px;
        width: 100%;
        height: 100%;
    }
    span[data-pip] {
        display: none;
        position: absolute;
        width: @pipWidth;
        height: @pipWidth;
        background: #000;
        border-radius: 100%;
    }
    // pip positions
    span[data-pip="tl"], span[data-pip="ml"], span[data-pip="bl"] {
        left: @leftPip;
    }
    span[data-pip="mm"] {
        top: @middlePip;
        left: @middlePip;
    }
    span[data-pip="tr"], span[data-pip="mr"], span[data-pip="br"] {
        left: @rightPip;
    }
    span[data-pip="tr"], span[data-pip="tl"] {
        top: @topPip;
    }
    span[data-pip="mr"], span[data-pip="mm"], span[data-pip="ml"] {
        top: @middlePip;
    }
    span[data-pip="br"], span[data-pip="bl"] {
        top: @bottomPip;
    }

    div[data-value="1"] > span[data-pip="mm"] { display: block; }

    div[data-value="2"] > span[data-pip="bl"],
    div[data-value="2"] > span[data-pip="tr"] { display: block; }

    div[data-value="3"] > span[data-pip="bl"],
    div[data-value="3"] > span[data-pip="mm"],
    div[data-value="3"] > span[data-pip="tr"] { display: block; }

    div[data-value="4"] > span[data-pip="tl"],
    div[data-value="4"] > span[data-pip="tr"],
    div[data-value="4"] > span[data-pip="bl"],
    div[data-value="4"] > span[data-pip="br"] { display: block; }

    div[data-value="5"] > span[data-pip="tl"],
    div[data-value="5"] > span[data-pip="tr"],
    div[data-value="5"] > span[data-pip="mm"],
    div[data-value="5"] > span[data-pip="bl"],
    div[data-value="5"] > span[data-pip="br"] { display: block; }

    div[data-value="6"] > span[data-pip="tl"],
    div[data-value="6"] > span[data-pip="tr"],
    div[data-value="6"] > span[data-pip="ml"],
    div[data-value="6"] > span[data-pip="mr"],
    div[data-value="6"] > span[data-pip="bl"],
    div[data-value="6"] > span[data-pip="br"] { display: block; }
</style>

<div class="outer1">
    <div class="outer2">
        <div class="outerCircle">
            <div data-value={value}>
                <span data-pip="tl"></span>
                <span data-pip="tr"></span>
                <span data-pip="ml"></span>
                <span data-pip="mm"></span>
                <span data-pip="mr"></span>
                <span data-pip="bl"></span>
                <span data-pip="br"></span>
            </div>
        </div>
    </div>
</div>